// AS MENSAGENS DE ERRO DO LOGIN, DO CADASTRO E DO CÓDIGO — do antigo `AuthShell`, sem mudar.

/**
 * Segundos de espera informados pelo Supabase no erro de rate limit, ou null.
 *
 * A resposta traz "For security purposes, you can only request this after 23 seconds." — e o
 * número é a única parte útil: sem ele a pessoa lê "aguarde um instante", não sabe se são 5 ou 60
 * segundos, e fica tentando de novo (o que renova o bloqueio).
 */
export const rateLimitSeconds = (err: any): number | null => {
  const m = /after (\d+)\s*second/i.exec(String(err?.message || ''));
  return m ? Number(m[1]) : null;
};

export const authError = (err: any): string => {
  const msg = (err?.message || '').toLowerCase();
  if (msg.includes('invalid login')) return 'E-mail ou senha incorretos.';
  if (msg.includes('already registered') || msg.includes('already exists'))
    return 'Este e-mail já está cadastrado. Entre na sua conta.';
  if (msg.includes('not confirmed')) return 'E-mail ainda não confirmado.';
  // Rate limit ANTES do genérico de "email" — senão "email rate limit exceeded" virava "e-mail inválido".
  if (msg.includes('rate limit') || msg.includes('for security purposes') || msg.includes('too many'))
    return 'Muitas tentativas em pouco tempo. Aguarde um instante e tente de novo.';
  if (msg.includes('otp') || msg.includes('expired') || (msg.includes('token') && msg.includes('invalid')))
    return 'Código inválido ou expirado. Toque em "Reenviar código".';
  if (msg.includes('provider is not enabled') || msg.includes('not enabled'))
    return 'Login social indisponível no momento. Use e-mail e senha.';
  if (msg.includes('password')) return 'A senha precisa ter ao menos 6 caracteres.';
  if (msg.includes('email')) return 'Informe um e-mail válido.';
  return err?.message || 'Algo deu errado. Tente novamente.';
};

/** O formato do e-mail, para o erro aparecer no campo antes de ir ao servidor. */
export const emailValido = (email: string) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim());

/** O erro do campo de e-mail (vazio ou fora do formato), ou nada. */
export const erroDoEmail = (email: string): string | undefined => {
  if (!email.trim()) return 'Informe seu e-mail.';
  return emailValido(email) ? undefined : 'Informe um e-mail válido.';
};
